<script>
export default {
    name: 'IconArrowTop'
}
</script>
<template>
    <svg
        class="base-icon icon-arrow-top"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            d="M8 31.97L31.9 8l.099.1.1-.1L56 31.97l-4.218 4.23-16.8-16.848V56h-5.964l-.001-36.648-16.8 16.849z"
            fill-rule="evenodd"
        />
    </svg>
</template>
